import React from 'react';

import { Table, Button, Icon } from 'semantic-ui-react';

import './ReviewsTableHeader.scss';

export default function ReviewsTableHeader({
  onDelete,
  approveReviews,
  disapproveReviews,
  amountSelected,
}) {
  return (
    <Table.Header>
      <Table.Row>
        <Table.HeaderCell width={2}>Reviewer</Table.HeaderCell>
        <Table.HeaderCell width={1}>Source</Table.HeaderCell>
        <Table.HeaderCell width={1}>Rating</Table.HeaderCell>
        <Table.HeaderCell width={6}>Review</Table.HeaderCell>
        <Table.HeaderCell width={2}>Location</Table.HeaderCell>
        <Table.HeaderCell width={2}>Response Status</Table.HeaderCell>
        <Table.HeaderCell width={3}>Actions</Table.HeaderCell>
      </Table.Row>
      {amountSelected > 0 && (
        <Table.Row className="bulk-actions">
          <Table.HeaderCell colSpan="8">
            <div className="bulk-actions-container">
              <span className="selected-count">{amountSelected} selected</span>
              <div className="action-buttons">
                <Button
                  size="small"
                  color="green"
                  onClick={approveReviews}
                  icon
                  labelPosition="left"
                >
                  <Icon name="check" />
                  Approve Selected
                </Button>
                <Button
                  size="small"
                  color="red"
                  onClick={disapproveReviews}
                  icon
                  labelPosition="left"
                >
                  <Icon name="times" />
                  Disapprove Selected
                </Button>
                <Button size="small" color="grey" onClick={onDelete} icon labelPosition="left">
                  <Icon name="trash" />
                  Delete Selected
                </Button>
              </div>
            </div>
          </Table.HeaderCell>
        </Table.Row>
      )}
    </Table.Header>
  );
}
